import { useMemo, useCallback } from "react";
import { useGetBreedsQuery } from "../rtk/animal/animal";
import i18n from "../i18n/i18n";

export interface BreedOption {
  label: string;
  value: string;
}

export const useFilteredBreeds = (species?: string) => {
  const { data: breeds } = useGetBreedsQuery({ language: i18n.language as any });

  const speciesFilter = species === "cat" ? "Cat" : species === "dog" ? "Dog" : undefined;

  const filteredBreeds = useMemo(
    () => breeds?.filter((breed) => breed.species === speciesFilter) ?? [],
    [breeds, speciesFilter]
  );

  const breedsOptions = useMemo(
    () => filteredBreeds.map((breed) => ({
      label: breed.breed_name,
      value: String(breed.id),
    })),
    [filteredBreeds]
  );

  const getBreedData = useCallback(
    (breedId: string | number | null | undefined) => {
      if (!breedId) return { breed: null, option: null };
      
      const breed = filteredBreeds.find((b) => String(b.id) === String(breedId)) ?? null;
      const option = breedsOptions.find((opt) => opt.value === String(breedId)) ?? null;
      
      return { breed, option };
    },
    [filteredBreeds, breedsOptions]
  );

  return {
    breeds,
    filteredBreeds,
    breedsOptions,
    getBreedData,
  };
};
